import React, { useState, useEffect } from 'react';
import Hero from './Hero/Hero';
import FeaturePowerhouse from './FeaturePowerhouse/FeaturePowerhouse';
import SocialSamples from './SocialSamples/SocialSamples';
import ComparisonSection from './ComparisonSection/ComparisonSection';
import Pricing from './Pricing/Pricing';
import SelfEditApp from './SelfEditApp/SelfEditApp';
import Feedback from './Feedback/Feedback';
import OtherServices from '../OtherServices/OtherServices';
import CallbackModal from './CallbackModal/CallbackModal'; // Ensure this path is correct

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // 1. Check if user has already seen/closed the popup in this session
    const hasSeenPopup = sessionStorage.getItem('ananta_popup_seen');

    if (!hasSeenPopup) {
      // 2. Set timer for 6 seconds (6000ms)
      const timer = setTimeout(() => {
        setIsModalOpen(true);
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // 3. Mark as seen so it doesn't pop up again during this visit
    sessionStorage.setItem('ananta_popup_seen', 'true');
  };

  return (
    <div style={{ backgroundColor: '#020617' }}>
      
      {/* Sections with IDs for Smooth Navigation */}
      <div id="home">
        <Hero/>
      </div>

      <div id="about">
        <FeaturePowerhouse/>
      </div>

      <div id="samples">
        <SocialSamples/>
      </div>

      <div id="why">
        <ComparisonSection/>
      </div>

      <div id="pricing">
        <Pricing/>
      </div>

      <div id="app-section">
        <SelfEditApp/>
      </div>

      <div id="feedback">
        <Feedback/>
      </div>

      <div id="services">
        <OtherServices/>
      </div>

      {/* Automatic Callback Popup */}
      <CallbackModal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal} 
      />
    </div>
  );
}

export default Home;